import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast, ToastContainer } from 'react-toastify';

import { copyToClipboard } from '../../../common/copyToClipboard';
import { TestGivingProps } from '../TestGiving/utilsTestGiving';
import momencik from '../../../common/momencik';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetTestDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

import { ExamOnline } from './ExamOnline';

export const ExtensionSummary: React.FC<{
  values: TestGivingProps;
  examined?: string;
  tests?: string;
  examsIds?: string[];
}> = ({ values, examined, tests, examsIds }) => {
  const [testsDto, setTestsDto] = useState<GetTestDto[] | undefined>();
  const [online, setOnline] = useState<boolean>(false);
  const spd = useSpdCore();

  useEffect(() => {
    if (examsIds && examsIds.length === 1) {
      spd.examTests
        .getByExam(examsIds[0])
        .then(o => setTestsDto(o.map(p => p.test).filter(p => !!p)))
        .catch(async error => {
          const err = await responseErrors(error);
          toast.error(
            `Wystąpił problem podczas pobierania testów badania. ${err}`,
          );
        });
    }
  }, [examsIds, spd.examTests]);

  const onClickExtensionHandle = async () => {
    await copyToClipboard(`
    ${values.company?.name || ''} - piny z dnia ${momencik(
      values.examPackage?.registrationDate,
    )}

    Liczba utworzonych badań: ${values.countOfExams}
    
    Badany: ${examined || '-'}
    
    Zlecone testy: ${tests || ''}
    
    Opis: ${values.description || ''}
    
    PIN: ${values.pin}`);
  };

  return (
    <>
      <Button
        className="me-2"
        onClick={onClickExtensionHandle}
        variant="outline-secondary"
      >
        Tekst wiadomości <Icon.ClipboardPlus />
      </Button>
      {examsIds && examsIds.length === 1 && !online && (
        <ExamOnline
          examId={examsIds[0]}
          tests={testsDto}
          online={false}
          className="me-2"
          setRefresh={() => setOnline(true)}
        />
      )}
      {online && <strong>BADANIE ONLINE</strong>}
      <ToastContainer />
    </>
  );
};
